import type { IGLMenuItem } from '@group-link-one/gl-components';

export const useNavMenuFilter = () => {
  const filterMenuItems = (items: IGLMenuItem[]): IGLMenuItem[] => {
    return items
      .filter(item => item.isToAppear)
      .map(item => {
        if (item.items?.length) {
          return {
            ...item,
            items: item.items.filter(dropdownItem => dropdownItem.isToAppear),
          };
        }
        return item;
      });
  };

  return { filterMenuItems };
};
